var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHero5 = function SvgHero5(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 119.5 204",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_5_svg__radial-gradient",
    cx: 13.6484,
    cy: -0.033,
    r: 225.15,
    gradientTransform: "translate(3.0508 3.0909) scale(0.9492 0.9697)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e69a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4491,
    stopColor: "#28d4a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fc1b6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_5_svg__radial-gradient-2",
    cx: 143.467,
    cy: 206.8597,
    r: 193.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_5_svg__radial-gradient-3",
    cx: -44.8354,
    cy: -5.0523,
    r: 240.8936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#a0f576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    stopColor: "#5ef9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_5_svg__radial-gradient-4",
    cx: 99.4505,
    cy: 224.7547,
    r: 189.5396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_5_svg__radial-gradient-5",
    cx: 170.6798,
    cy: 126.353,
    r: 134.4332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#42c0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8041,
    stopColor: "#83cb9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccf99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_5_svg__radial-gradient-6",
    cx: 86.3232,
    cy: 195.8845,
    r: 146.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0289,
    stopColor: "#00aca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#2ad19f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_5_svg__radial-gradient-7",
    cx: 45.1484,
    cy: 159.2363,
    r: 55.8405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "hero_5_svg__hero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_5_svg__middle-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_5_svg__bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.2542,6,44.8136,20.5455Q24.4067,51.5757,4,82.6061l12.339,45.5757,18.983,18.4243,19.9322,8.7272L106.5085,198q4.7457-39.7575,9.4915-79.5152Q113.6272,62.2425,111.2542,6Z",
    style: {
      fill: "url(#hero_5_svg__radial-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_5_svg__shapes_shard_02_color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,83l2-1,31,1,20,31-4.5,27.5L38,147l-4,1L14.5,129.5Q7.25,106.25,0,83Z",
    style: {
      fill: "url(#hero_5_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,0l-3,5L35,82l-2.5,1.5L0,83,45,16Z",
    style: {
      fill: "url(#hero_5_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5,118.5l-1.5.5-64-4-2-1L32.5,83.5,116,0Q117.75,59.25,119.5,118.5Z",
    style: {
      fill: "url(#hero_5_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,116.5,89,118,59,156l-1,4,52,44q4.75-42.75,9.5-85.5Z",
    style: {
      fill: "url(#hero_5_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,160l-2-3-8-14v-2q2-13.5,4-27l39.5,2.5Z",
    style: {
      fill: "url(#hero_5_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,148l14-7,10,19Z",
    style: {
      fill: "url(#hero_5_svg__radial-gradient-7)"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHero5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hero_5.9d32492090012c777475ede25c489f50.svg";